module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/coupons/coupons.component.css
// module id = ./src/app/components/coupons/coupons.component.css
// module chunks = main